[
   {
    "title": "2025 - 50 anni fa: L'omicidio di Pasolini",
    "subtitle": [
      "Una manifestazione organizzata assieme all'associazione italo-tedesca di Düsseldorf"
    ],
    "bodycopy": [
      "Breve conferenza del Dr. Thomas Brückner (docente privato): Omaggio a Pasolini e introduzione al film UCCELLACCI E UCCELLINI a cui segue"
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "UCCELLACCI E UCCELLINI",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1965,
        "runtime": 85,
        "version": "OmU",
        "screeningDate": "20.11.2025",
        "readableDate": "2025-11-20",
        "screeningTime": "21:30",
        "actors": "Totò, Ninetto Davoli,·Femi Benussi, Rossana Di Rocco, Lena Lin Solaro",
        "subtitle": [
          "Un film di Pier Paolo Pasolini forte e poetico, concentrato sulla fragilità e la bellezza della natura nonché sui complessi rapporti tra gli esseri viventi. Con la sua tipica mescolanza di profonde riflessioni critico-sociali e raffinatezza estetica, Pasolini ci mostra un mondo in cui gli uccelli rappresentano la libertà, la brama e la fugacità nella vita."
        ],
        "bodycopy": [
          "Padre e figlio camminano su una noiosa strada in mezzo ad una campagna monotona. Li accompagna un corvo filosofeggiante. E passando tra la raffigurazione delle sue favole, la realizzazione fantasiosa dei racconti del padre con i suoi episodi nasce un film riflessivo e allo stesso tempo divertente."
        ],
        "image": "../../uccellacci e uccellini.jpg"
      }
    ]
  },
  {
    "title": "",
    "subtitle": [""],
    "bodycopy": [""],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "ENNIO",
        "director": "Giuseppe Tornatore",
        "country": "Italien",
        "releaseYear": 2022,
        "runtime": 156,
        "version": "OmU",
        "screeningDate": "03.06.2023",
        "readableDate": "2023-06-03",
        "screeningTime": "20:00",
        "subtitle": [
          "È il film che inaugura la rassegna SPOTLIGHT ON ENNIO MORRICONE in programma in giugno nella sala Black Box. Dopo il film stuzzichini e bevande nel foyer."
        ],
        "bodycopy": [
          "Con ENNIO Giuseppe Tornatore ha creato un vero monumento in onore di Ennio Morricone, il compositore di colonne sonore più noto e più proficuo del cinema del XX secolo. Famoso divenne con la musica di C'ERA UNA VOLTA IL WEST e ancor oggi molti associano il suo nome ai western all'italiana, per i quali compose molti brani musicali.",
          "Nell'ambito di un'avvincente sequenza di scene raffiguranti la vita e l'operato di Morricone, Tornatore monta le interviste con il Maestro e altri musicisti intervallandole con osservazioni e ricordi di registi che hanno lavorato con lui.",
          "Con ENNIO Giuseppe Tornatore ha creato un vero monumento in onore di Ennio Morricone, il compositore di colonne sonore più noto e più proficuo del cinema del XX secolo. Famoso divenne con la musica di C'ERA UNA VOLTA IL WEST e ancor oggi molti associano il suo nome ai western all'italiana, per i quali compose molti brani musicali.",
          "Costituiscono dei punti salienti del film delle testimonianze ancora sconosciute della vita di Morricone nonché alcune riprese originali di lui mentre compone la sua musica e dirige i suoi concerti. Si tratta di materiali provenienti in parte da archivi privati a cui Tornatore ha potuto accedere solamente perché è stato legato da una profonda amicizia con il Maestro stesso e la sua famiglia. Un film che entusiasmerà non solo gli appassionati di musica.",
          "Ecco gli altri film della rassegna che saranno proiettati in giugno: C'era una volta il West (Dom. 04.06.2023–17:00 h), Il federale (Ven. 09.06.2023–21.00 h), Sacco e Vanzetti  (Sab. 10.06.2023–18.30 h), Uccellacci e uccellini (Dom. 11.06.2023–15:00 h), Queimada (Dom. 18.06.2023–17:15 h), Peur sur la ville–Angst über der Stadt (Ven. 25.06.2023–18:30 h), Una pura formalità (Dom. 25.06.2023–15:00 h), The Mission (Gio. 29.06.2023–20.00 h)"
        ],
        "image": "../../Ennio.jpg"
      }
    ]
  },
  {
    "title": "",
    "subtitle": [""],
    "bodycopy": [""],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "MAMMA ROMA",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1962,
        "runtime": 105,
        "version": "OmU",
        "screeningDate": "14.01.2023",
        "readableDate": "2023-01-14",
        "screeningTime": "21:00",
        "actors": "Anna Magnani, Ettore Garofolo, Franco Citti, Silvana Corsini u.a.",
        "subtitle": [
          " Il restauro di MAMMA ROMA è stato eseguito nel 2022 dal Centro Sperimentale di Cinematografia Cineteca Nazionale in base a pellicole negative e con la colonna sonora messa a disposizione da RTI-Mediaset in cooperazione con Infinity+ e Cine 34. Per produrre una versione completa del film, alcune parti, che mancavano tra i negativi o erano compromesse, sono state combinate con un positivo conservato nella Cineteca Nazionale. "
        ],
        "bodycopy": [
          "Mama Roma cerca di lasciare dietro di sé il passato. Carmine, il suo magnaccia e padre di suo figlio, sposa un'altra donna. E lei vuole iniziare una nuova vita. Mamma Roma si trasferisce in un quartiere borghese con il figlio sedicenne, cresciuto in un collegio fuori città, e si mette a vendere frutta e verdura. La nuova vita assieme al ragazzo si rivela estremamente complicata e improvvisamente ricompare Carmine, che nel frattempo si è separato dalla moglie. Carmine pone un ultimatum a Mamma Roma. ",
          "\"In questo film ci sono dei momenti di sconvolgente bellezza che si affiancano a immagini di decadenza, anzi che nascono da tale declino e vi rifluiscono. Quando Ettore dopo un furto meschino e un tentativo di suicidio viene ricoverato in psichiatria, uno degli altri pazienti recita brani dall'Inferno di Dante. Subito dopo risuona Vivaldi. Bisogna viverlo al cinema per credere che questo momento non precipiti nel kitsch\". (Claus Löser)"
        ],
        "image": "../../mamma-roma-1.jpg"
      },
      {
        "title": "GRUPPO DI FAMIGLIA IN UN INTERNO (GEWALT UND LEIDENSCHAFT)",
        "director": "Luchino Visconti",
        "country": "Italia/Frankreich",
        "releaseYear": 1974,
        "runtime": 121,
        "version": "OmU",
        "screeningDate": "22.01.2022",
        "readableDate": "2022-01-22",
        "screeningTime": "19:00",
        "actors": "Burt Lancaster, Helmut Berger, Silvana Mangano u.a.",
        "subtitle": [
          "Una cooperazione tra il team \"Neu restauriert (da poco restaurato)\" e il \"Filmclub del Cinema Italiano (entrambi del Museo del Cinema di Düsseldorf).",
          "In una casa lussuosa con un arredamento ormai antiquato vive ritirato e solo un vecchio professore assieme ai suoi quadri, fotografie, libri, oggetti d'arte e ricordi. Piano piano nel corso degli anni si è sempre più isolato, ma affitta, anche se di malavoglia, l'appartamento vuoto del suo palazzo. I ragazzi e le ragazze che ci abitano lo mettono a confronto con un mondo moderno e conturbante, sconvolgendo la sua vita pacifica e ritirata. Fa amicizia soprattutto con Konrad, un giovane ex sessantottino, sviluppando verso di lui un rapporto paterno. "
        ],
        "bodycopy": [
          "“Si tratta della storia di un intellettuale. Attraverso il contatto con un gruppo di giovani pieni di vitalità e sventatezza, interessati solamente a spazzar via tutto quello che c'era prima di loro, il vecchio avverte tutto il peso della sua solitudine”. (Luchino Visconti)",
          "L'allestimento gioca un ruolo decisivo nel film. Visconti descrive l'ambiente familiare con scrupolosa esattezza quasi volesse dipingere un quadro nello stile del XVIII secolo. L'amore per i dettagli e la precisione si avvertono in ogni inquadratura.",
          "Il restauro del film è avvenuto nel 2013 nel Centro sperimentale di Cinematografia - Cineteca Nazionale di Roma."
        ],
        "image": "../../gewalt-und-leidenschaft.jpg"
      }
    ]
  },

  {
    "title": "2020 - Ciao Aracà",
    "subtitle": [
      "Ospite nella sala Black Box: Daniel Chisholm, il regista e autore di CIAO ARACÀ"
    ],
    "bodycopy": [
      "Non proiettato nel 1° semestre a causa della chiusura dovuta al Covid-19, ora riprogrammato."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Ciao Aracà (Ciao Aracà)",
        "director": "Daniel Chisholm",
        "country": "Germania",
        "releaseYear": 2019,
        "runtime": 63,
        "version": "OmU",
        "screeningDate": "17.09.2020",
        "readableDate": "2020-09-17",
        "screeningTime": "20:00",
        "actors": "Es treten auf: ehemalige und aktuelle Bewohner von Aracà",
        "subtitle": [
          "Non proiettato nel 1° semestre a causa della chiusura dovuta al Covid-19, ora riprogrammato.",
          "Ospite nella sala Black Box: Daniel Chisholm, il regista e autore di CIAO ARACÀ",
          "Un paese rurale in Italia sta andando in rovina, ma i suoi abitanti ormai invecchiati cercano di impedirlo con coraggio mentre la nuova generazione lotta per la sopravvivenza nella piccola comunità. "
        ],
        "bodycopy": [
          "Aracà, un villaggio sulle montagne liguri, è in subbuglio. I vecchi contadini e le loro famiglie devono affrontare una serie di gravi problemi. La perdita dei tradizionali metodi di coltivazione, i mercati agricoli globalizzati, l'emigrazione dei giovani e l'afflusso di estranei, che comprano gli immobili a buon prezzo. Nonostante queste sfide esistenziali affrontano il futuro con grazia, dignità, stoicismo e un astuto senso dell'umorismo.",
          "Allo stesso tempo i loro discendenti rimasti nel luogo si danno da fare per frenare il declino dell'ambiente rurale investendo in nuovi vitigni, in nuovi attrezzi per la produzione di vino, nel ringiovanimento degli oliveti, in moderne macchine agricole e in una migliore commercializzazione dei loro prodotti. Sebbene abbiano riconosciuto che la qualità e la provenienza siano di grande importanza, le loro possibilità di farcela rimangono incerte.",
          "CIAO ARACÀ documenta la vita dei contadini e delle loro famiglie. Con accuratezza e sensibilità il regista illustra la lotta di un piccolo comune contro l'industrializzazione e la globalizzazione senza perdere di vista i brevi momenti di sollievo che pure esistono."
        ],
        "image": "../../ciaoaraca.png"
      },
      {
        "title": "Il Decameron (Dekameron)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1971,
        "runtime": 112,
        "version": "OmenU",
        "screeningDate": "05.10.2022",
        "readableDate": "2022-10-05",
        "screeningTime": "20:00",
        "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
        "subtitle": [
          "Una cooperazione tra la Società Italo-Tedesca e.V. - Dante Alighieri - Düsseldorf e il Club del Cinema Italiano ",
          "IL DECAMERON assieme a I RACCONTI DI CANTERBURY e IL FIORE DELLE MILLE E UNA NOTTE costituisce la Trilogia della vita. Pasolini ha riunito tre opere che, pur avendo una struttura simile, fanno parte del patrimonio letterario di diverse epoche e culture. Le ha scelte per raffigurare in modo spassoso le questioni esistenziali per la vita dell’individuo e per il suo ruolo nella società."
        ],
        "bodycopy": [
          "Ispirandosi all’omonima opera del Boccaccio, Pasolini presenta negli otto episodi del suo DECAMERON la sessualità e il piacere dei sensi in un tetro mondo arcaico. Una violenza insidiosa minaccia sempre e dovunque la vita delle persone semplici che esprimono la loro gioia di vivere nell’appagamento dei loro istinti sessuali.",
          "Diversamente dalla cornice narrativa di Boccaccio, basata su un gruppo di giovani sfuggiti alla peste, che passano il tempo raccontandosi novelle, Pasolini congiunge gli otto episodi attraverso la figura di un pittore allievo di Giotto.",
          "Introdurrà il film Donatella Chiancone-Schneider, storica dell’arte e del cinema, che ne sottolineerà gli aspetti artistici e storico-cinematografici nel contesto della filmografia pasoliniana e li confronterà con le opere letterarie e pittoriche che hanno ispirato il regista."
        ],
        "image": "../../ildecameron.jpg"
      }
    ]
  },
  {
    "title": "2020 - IL GATTOPARDO",
    "subtitle": [
      "In cooperazione con la Deutsch-Italienischen-Gesellschaft  / Società Italo-Tedesca e.V. – Dante Alighieri - Düsseldorf "
    ],
    "bodycopy": [
      "Lo spettacolo accompagna la maratona letteraria organizzata dall’NRW Literaturbüro e.V. (Gerhard-Hauptmann-Haus) che si svolge il 6 marzo 2020: Tommasi di Lampedusa \"Il Gattopardo\""
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Il Gattopardo",
        "director": "Luchino Visconti",
        "country": "Italia/Frankreich",
        "releaseYear": 1963,
        "runtime": 180,
        "version": "OmU",
        "screeningDate": "08.03.2020",
        "readableDate": "2020-03-08",
        "screeningTime": "16:00",
        "actors": "Burt Lancaster, Claudia Cardinale, Alain Delon, Paolo Stoppa u.a.",
        "subtitle": [
          " Non appena pubblicato nel 1958 “Il Gattopardo” di Tomasi di Lampedusa, che descrive i rivolgimenti sociali del XIX secolo in Italia, fu immediatamente considerato un capolavoro della letteratura mondiale. Quattro anni dopo, nel 1962, Luchino Visconti basandosi sul romanzo girò un film che si annovera tra i migliori della storia del cinema. Si tratta della storia del passaggio dal potere feudale a quello borghese descritta con gli strumenti del cinema, in immagini di straordinaria magnificenza e decadente splendore."
        ],
        "bodycopy": [
          "L’anziano principe di Salina, Don Fabrizio (Burt Lancaster) vede avanzare l’erosione del potere nobiliare e si rifiuta di collaborare con il nuovo Regno d’Italia. Allo stesso tempo promuove il matrimonio di suo nipote Tancredi (Alain Delon) con Angelica (Claudia Cardinale), la figlia del sindaco. Visconti mette in scena l’incontro della nuova e della vecchia società in una grande sala da ballo con una coreografia indimenticabile.",
          "Con simpatia e spirto critico il film accompagna l’ultima fase della vita del principe. Leggendaria è anche oggi la frase, pronunciata dal giovane Tancredi, nel romanzo e nel film, per spiegare allo zio il cambiamento in corso: “Se vogliamo che tutto rimanga come è, bisogna che tutto cambi.\"",
          "\"Un toccante panorama storico e sociale di incredibile bellezza e precisione analitica\" (Lexikon des Internationalen Films)"
        ],
        "image": "../../Il gattopardo.jpg"
      }
    ]
  },
  {
    "title": "2019 - ORECCHIE",
    "subtitle": [
      "Ospite nella Black Box: ALESSANDRO ARONADIO con il suo film ORECCHIE"
    ],
    "bodycopy": [
      "Le opere cinematografiche di Alessandro Aronadio hanno molte sfaccettature: Il doppio nei film di Cronenberg era stato il tema della tesi di laurea in psicologia di questo regista nato nel 1975. Da allora lavora come fotografo e come scrittore di successo, ma principalmente come assistente alla regia di numerosi film, fiction e documentari, sia per il cinema che per la TV.  Ha ricevuto vari premi per i propri cortometraggi e videoclip. La sua virtuosità viene a galla nei tre lungometraggi che ha girato finora: DUE VITE PER CASO approfondisce il confronto con il tema della casualità, sulle orme di Kieslowski e Tykwer. In ORECCHIE crea un nuovo linguaggio visivo in bianco e nero per il genere della commedia. Il suo terzo film DIO C’È condensa un confronto intellettuale con le religioni del mondo in una commedia all’italiana. Tutti i suoi film si occupano di questioni riguardanti l'esistenza umana, raccontate con fantasia visiva, profondità e leggerezza."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Orecchie",
        "director": "Alessandro Aronadio",
        "country": "Italia",
        "releaseYear": 2016,
        "runtime": 90,
        "version": "OmU",
        "screeningDate": "31.10.2019",
        "readableDate": "2019-10-31",
        "screeningTime": "20:00",
        "actors": "Daniele Parisi, Silvia D'Amico, Rocco Papaleo, Pamela Villoresi, Ivan Franek, Piera Degli Esposti, Milena Vukotic, Paolo Giovannucci, Andrea Purgatori, Massimo Wertmüller, Francesca Antonelli, Niccolò Senni, Masaria Colucci, Silvana Bosi, Sonia Gessner",
        "subtitle": [
          "Girata in bianco e nero, questa commedia tratta quasi accidentalmente questioni esistenziali in una sequenza di situazioni spassose, curiose e assurde. Una fotografia severa e una composizione scenica quasi accademica creano un quadro di contrasto che ne sottolinea la serietà.",
          "In cooperazione con l'Istituto Italiano di Cultura di Colonia.",
          "Con il gentile supporto dell'Hotel Orangerie, Düsseldorf."
        ],
        "bodycopy": [
          "Un uomo si sveglia un mattino con un fischio nell'orecchio... che non lo lascia in pace per tutto il film. Sul frigorifero trova un foglietto \"Il tuo amico Luigi è morto\". Ma chi è questo Luigi? Questo è l'inizio di una giornata tragicomica con medici sadici, suore invadenti, una star dell'hip-hop in un ambiente speciale, la domanda di come riuscire a far sorridere la sua fidanzata, e l'incontro con la madre che sta vivendo la sua seconda primavera con un artista che chiama “Performance” le sue opere. E poi di nuovo questo Luigi di cui non riesce a ricordarsi in nessun modo."
        ],
        "image": "../../orecchie-5.jpg"
      }
    ]
  },
  {
    "title": "2018 - LA CICCIOLINA. GÖTTLICHE SKANDALNUDEL",
    "subtitle": [
      "Introduzione: Joachim Manzin (Manzin – italienische Übersetzungen",
      "Moderazione: Daniela Bacchini"
    ],
    "bodycopy": [
      "Alessandro Melazzini è un artista che si dedica a temi di attualità servendosi di immagini e parole: italiano di nascita, ma residente in Germania, nei suoi documentari affronta questioni che toccano entrambi i Paesi. Inoltre lavora come pubblicista per quotidiani tedeschi e italiani (ad es. Il Sole 24 ore e Süddeutsche Zeitung). Lui stessi si definisce mediatore tra le culture dei due paesi e nell'ambito di manifestazioni cerca il contatto con il pubblico. A Düsseldorf viene con il suo ultimo film prodotto per ARTE: LA CICCIOLINA."
    ],
    "extra": {
      "text": "Veranstaltung in Zusammenarbeit mit:",
      "links": [
        {
          "label": "Italia Altrove e.V.",
          "link": ""
        },
        {
          "label": "Deutsch-Italienische Gesellschaft",
          "link": ""
        },
        {
          "label": "Manzin. Italienische Übersetzungen",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "LA CICCIOLINA. GÖTTLICHE SKANDALNUDEL",
        "director": "Alessandro Melazzini",
        "country": "Germania/Frankreich",
        "releaseYear": 2016,
        "runtime": 54,
        "version": "OmU",
        "screeningDate": "05.12.2018",
        "readableDate": "2018-12-05",
        "screeningTime": "20:00",
        "actors": "Ilona Staller (Cicciolina), Michele Lo Foco, Filippo Ceccarelli, Marco Gregoretti, Gianfranco Spadaccia, Jeff Koons",
        "subtitle": [""],
        "bodycopy": [
          "In una carrellata biografica mette in luce il fenomeno Ilona Staller, in arte Cicciolina, ovvero l'icona della pornografia. Nata in Ungheria nel 1951, Cicciolina arriva con un matrimonio in Italia dove, degli anni 1970, diventa in breve un’icona pop del porno. Sfruttando la sua notorietà e la sua fama nel 1987 riesce ad entrare nel Parlamento italiano come deputata del Partito Radicale. Il fatto suscita enorme scalpore a livello internazionale e provoca grandi cambiamenti nei rapporti politici italiani anche se le iniziative di legge proposte da Cicciolina non sono provocatorie, ma piuttosto costruttive (protezione degli animali, tutela ambientale, situazione dei detenuti, ecc.). Attraverso un contatto di lavoro conosce Jeff Koons, lo sposa, fa un figlio con lui e lo ispira nelle sue opere, altamente quotate nel mercato dell'arte. Dopo breve tempo il matrimonio fallisce. Cicciolina si ritira dal mondo della pornografia, ma rimane attiva politicamente sulla scena internazionale.",
          "Alla fine il film di Melazzini si pone la domanda se Cicciolina, che aveva concentrato la campagna elettorale sulla sua persona e sul suo talento per lo spettacolo, non abbia cambiato il modo di intendere i politici nell'opinione pubblica tanto da aprire la strada a un personaggio dei media e dello show come Berlusconi."
        ],
        "image": "../../la-cicciolina.jpg"
      }
    ]
  },
  {
    "title": "2016 - CLUB DEL CINEMA ITALIANO SPECIALE: WESTERN ALL’ITALIANA",
    "subtitle": [""],
    "bodycopy": [
      "Django, Sabata, Sartana. Qualsiasi cinefilo conosce le figure dei western all'italiana che rimandano all'epoca d'oro del cinema italiano. Le pellicole di Quentin Tarantino, Robert Rodriguez o John Woo riprendono questo filone della storia del cinema aggiornandolo. Il Club del Cinema Italiano segue le tracce di questo genere con quattro film."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "CIPOLLA COLT (ZWIEBEL-JACK RÄUMT AUF)",
        "director": "Enzo G. Castellari (als Enzo Girolami)",
        "country": "Italia/Spanien/Germania",
        "releaseYear": 1975,
        "runtime": 91,
        "version": "OmU",
        "screeningDate": "25.09.2016",
        "readableDate": "2016-09-25",
        "screeningTime": "16:30",
        "actors": "Franco Nero, Sterling Hayden, Martin Balsam, Emma Cohen, Leo Anchóriz, Romano Puppo",
        "subtitle": [""],
        "bodycopy": [
          "In questa commedia parodistica Franco Nero (“Django”) interpreta un coltivatore di cipolle che se la prende con un magnate del petrolio che mira alla sua terra e alla sua vita. Elementi della Commedia dell'arte e della Commedia all’italiana si coniugano con la tradizione dello slapstick. Il film ironizza la fase precedente di questo genere basata su una comicità sciocca e banale."
        ],
        "image": "../../cipolla-colt-1.jpg"
      },
      {
        "title": "DJANGO",
        "director": "Sergio Corbucci",
        "country": "Italia/Spanien",
        "releaseYear": 1966,
        "runtime": 91,
        "version": "OmU",
        "screeningDate": "15.09.2016",
        "readableDate": "2016-09-15",
        "screeningTime": "20:00",
        "actors": "Franco Nero, José Canalejas, José Bódalo, Loredana Nusciak, Ángel Álvarez, Gino Pernice, Simón Arriaga, Giovanni Ivan Scratuglia",
        "subtitle": [""],
        "bodycopy": [
          "Nella lotta fra due gruppi di banditi si immischia uno straniero che trascina dietro a sé una cassa da morto contenente una mitragliatrice: Django. “Questo appassionante e brutale italo-western, caratterizzato da una struttura singolare, ebbe un tale successo commerciale da produrre una vera e propria valanga di Django”. (Filmdienst)"
        ],
        "image": "../../django-2.jpg"
      },
      {
        "title": "FACCIA A FACCIA (VON ANGESICHT ZU ANGESICHT)",
        "director": "Sergio Sollima",
        "country": "Italia/Spanien",
        "releaseYear": 1967,
        "runtime": 112,
        "version": "OmU",
        "screeningDate": "03.09.2016",
        "readableDate": "2016-09-03",
        "screeningTime": "19:00",
        "actors": "Gian Maria Volontè, Tomas Milian, William Berger, Jolanda Modio, Gianni Rizzo, Carole André, Ángel del Pozo",
        "subtitle": [""],
        "bodycopy": [
          "Un duello di altro tipo: Fletcher, preso come ostaggio dal bandito Bennet, comincia a prender gusto per la vita criminale, mentre il delinquente si rimette sulla buona strada. FACCIA A FACCIA, dopo la RESA DEI CONTI, è il secondo film di una trilogia ed è considerato uno dei più profondi tra i western all'italiana. Infatti si occupa di questioni come la relatività delle questioni morali in ambienti criminali."
        ],
        "image": "../../faccia-a-faccia-2.jpg"
      },
      {
        "title": "LA RESA DEI CONTI (DER GEHETZTE DER SIERRA MADRE)",
        "director": "Sergio Sollima",
        "country": "Italia/Spanien",
        "releaseYear": 1966,
        "runtime": 110,
        "version": "OmU",
        "screeningDate": "02.09.2016",
        "readableDate": "2016-09-02",
        "screeningTime": "21:15",
        "actors": "Lee Van Cleef, Tomas Milian, Walter Barnes, Nieves Navarro, Gérard Herter, Maria Granada, Roberto Camardiel, Ángel del Pozo, Luisa Rivelli",
        "subtitle": [""],
        "bodycopy": [
          "Il cacciatore di taglie Corbett insegue Cuchillo, il presunto assassino di una ragazza. Quando, superate alcune avversità, finalmente lo trova, capisce che è innocente e i due si mettono alla ricerca dei veri assassini. L'avvincente storia, gli ottimi attori e le eccezionali riprese del paesaggio fanno di questo film uno dei grandi classici di questo genere. La famosa colonna sonora - riutilizzata da Quentin Tarantino in BASTARDI SENZA GLORIA - è di Ennio Morricone."
        ],
        "image": "../../la-resa-dei-conti.jpg"
      }
    ]
  },
  {
    "title": "2015 - FRANCO MARESCO - BELLUSCONE. UNA STORIA SICILIANA",
    "subtitle": [
      "La manifestazione doveva svolgersi in presenza del regista siciliano Franco Maresco che purtroppo si è ammalato e perciò ha dovuto cancellare il viaggio a Düsseldorf."
    ],
    "bodycopy": [
      "L'occasione è sia la presentazione del libro sulla sua attività cinematografica svolta assieme a Daniele Ciprì sia la proiezione del suo ultimo film.",
      "Presentazione del libro di Sieglinde Borvitz: CONTROCORRENTE – DIE KRUDEN VISIONEN VON CIPRÌ UND MARESCO",
      "Secondo la tesi di questo libro entrambi i registi rivelano i meccanismi della \"governementalità\" mediale in Italia alimentando un conflitto semiotico che riguarda la ripartizione politica del sensoriale, e cioè della nostra percezione."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "BELLUSCONE. UNA STORIA SICILIANA (BELLUSCONE - WARUM DIE ITALIENER BERLUSCONI LIEBEN)",
        "director": "Franco Maresco",
        "country": "Italia",
        "releaseYear": 2014,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "06.07.2015",
        "readableDate": "2015-07-06",
        "screeningTime": "20:00",
        "actors": "",
        "subtitle": [""],
        "bodycopy": [
          "Sono i protagonisti bislacchi di Maresco che assicurano i voti a Berlusconi, chiamato in Sicilia semplicemente \"Belluscone\". Le strade di Palermo, nelle immagini di Maresco, appaiono come un mondo mafioso parallelo nel quale una mano lava l'altra, e dal quale non c'è scampo. Maresco mette in luce con tutta la sua spaventosa evidenza come funzioni il sistema della mafia nel suo piccolo. "
        ],
        "image": "../../belluscone.jpg"
      }
    ]
  },
  {
    "title": "2015 - UNA VITA TRANQUILLA",
    "subtitle": [
      "18.00 Uhr - Laura Garavini parla dei rapporti italo-tedeschi, della mafia e dell’Europa e invita a discuterne insieme."
    ],
    "bodycopy": [
      "Note biografiche:",
      "Laura Garavini è nata il 23 luglio 1966 a Vignola (MO) e vive dal 1989 in Germania e in Italia. Nel 2007, assieme a noti ristoratori italiani, ha fondato a Berlino l’iniziativa \"Mafia? No, grazie!“ . Nel 2008 è stata eletta nella Camera dei Deputati come rappresentante degli italiani residenti all’estero e dal novembre 2008 fino a marzo 2013 ha ricoperto la carica di presidente del gruppo parlamentare del Partito Democratico nella Commissione antimafia del Parlamento italiano. Nel 2013 si è ricandidata con successo nel collegio elettorale europeo. Dal marzo 2014 è presidente della Commissione per la lotta contro la criminalità organizzate a livello europeo e internazionale. Attualmente presiede il Gruppo parlamentare per l’amicizia italo-tedesca."
    ],
    "extra": {
      "text": "Uno spettacolo speciale del Club del Cinema Italiano in cooperazione con la",
      "links": [
        {
          "label": "Società italo-tedesca e.V. Dante Alighieri.",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "UNA VITA TRANQUILLA (EIN RUHIGES LEBEN - DIe Mafia vergisst nicht)",
        "director": "Claudio Cupellini",
        "country": "Italia/Deutschlanf/Frankreich",
        "releaseYear": 2010,
        "runtime": 105,
        "version": "OmU",
        "screeningDate": "16.05.2013",
        "readableDate": "2013-05-16",
        "screeningTime": "20:00",
        "actors": "Toni Servillo, Marco D'Amore, Francesco Di Leva, Juliane Köhler, Maurizio Donadoni, Alice Dwyer, Leonardo Sprengler",
        "subtitle": [""],
        "bodycopy": [
          "Un aspetto dei rapporti italo-tedeschi nella vita quotidiana di una famiglia: un ex mafioso ha fondato una famiglia in Germania, dove ha aperto un ristorante. Improvvisamente arriva il suo primo figlio dall’Italia che sconvolge il suo mondo."
        ],
        "image": "../../una-vita-tranquilla.jpg"
      }
    ]
  },

  {
    "title": "2015 - IL CARATTERE ITALIANO. LA STORIA DI UNA GRANDE ORCHESTRA ITALIANA. (DIE ITALIENISCHE ART. DIE GESCHICHTE EINES GROßEN ITALIENISCHEN ORCHESTERS.)",
    "subtitle": [
      "Il carattere italiano: un film sulla musica, un film nella musica."
    ],
    "bodycopy": [""],
    "extra": {
      "text": "Uno spettacolo speciale del Club del Cinema Italiano in cooperazione con la",
      "links": [
        {
          "label": "Società italo-tedesca e.V. Dante Alighieri.",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "IL CARATTERE ITALIANO. LA STORIA DI UNA GRANDE ORCHESTRA ITALIANA. (DIE ITALIENISCHE ART. DIE GESCHICHTE EINES GROßEN ITALIENISCHEN ORCHESTERS)",
        "director": "Angelo Bozzolini",
        "country": "Germania/Italia",
        "releaseYear": 2013,
        "runtime": 100,
        "version": "OmU",
        "screeningDate": "01.03.2015",
        "readableDate": "2015-03-01",
        "screeningTime": "12:00",
        "actors": null,
        "subtitle": [""],
        "bodycopy": [
          "L’Orchestra dell’Accademia Nazionale di Santa Cecilia suonerà il 3 marzo 2015 a Düsseldorf nella Tonhalle. Con due giorni di anticipo mostriamo questo documentario sulla storia dell’orchestra, dei suoi membri e della sua musica.",
          "Mediante riprese attuali e pregiato materiale d’archivio la pellicola disegna un ritratto dell’Orchestra. Grazie al film lo spettatore vive da vicino i preparativi di un concerto, conosce i musicisti e la loro musica, condivide con loro sia l’attesa trepidante dell’esecuzione sia il sollievo e la gioia che provano dopo l’applauso finale del pubblico."
        ],
        "image": "../../die-italienische-art.jpg"
      }
    ]
  },
  {
    "title": "2014 - La meglio gioventù",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "All’inizio fu profetizzato ai due iniziatori Marisa e Joachim Manzin: “Non riuscirete a tener duro per più di tre anni!” Talvolta una previsione negativa aiuta a dimostrare il contrario. Perciò el nostro normale programma mensile riproponiamo i film che hanno avuto maggiore successo di pubblico in questi dieci anni (vedi rubrica: Programma)",
      "L’anniversario, invece, vogliamo festeggiarlo di sabato con un film monumentale, relativamente recente, che si impegna a raccontare oltre 40 anni di storia d’Italia, dagli anni ‘60, quelli del boom, a quelli della stagnazione fino al 2003, anno di produzione del film.",
      "Una pausa con una paella, il risotto alla spagnola con i frutti di mare, vino e bibite analcoliche (il tutto sponsorizzato da \"Manzin, Traduzioni italiano-tedesco\") permetterà di prendere fiato, sgranchirsi le gambe e scambiare impressioni con gli altri spettatori."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "La meglio gioventù (Die besten Jahre)",
        "director": "Marco Tullio Giordana",
        "country": "Italia",
        "releaseYear": 2003,
        "runtime": 366,
        "version": "OmU",
        "screeningDate": "22.03.2014",
        "readableDate": "2014-03-22",
        "screeningTime": "17:00",
        "actors": "Alessio Boni, Luigi Lo Cascio, Jasmine Trinca, Adriana Asti, Sonia Bergamasco, Fabrizio Gifuni, Maya Sansa, Camilla Filippi, Valentina Carnelutti",
        "subtitle": [
          "10° anniversario: i maggiori successi del Club del Cinema Italiano"
        ],
        "bodycopy": [
          "In Germania è stato Edgar Reitz con il suo progetto HEIMAT a raccontare la storia del Paese in base alla biografia di persone le cui vite si intrecciano. In Italia l’impresa se l’è assunta Marco Tullio Giordana che ha realizzato questo film seguendo lo stesso concetto: iniziando dagli anni ’60, quelli del boom e della solidarietà, racconta le vicende della famiglia Carati a Roma per oltre 40 anni. In questo lungo periodo ogni membro della famiglia prende le sue decisioni fortemente influenzate dallo sviluppo politico del Paese. Il risultato è un quadro storico della società italiana con le sue contraddizioni, un quadro divertente, interessante e drammaticamente condensato, il cui valore è stato riconosciuto da oltre 20 premi nazionali e internazionali.",
          "“Talvolta si afferma con leggerezza di non aver visto semplicemente un film, ma di aver fatto una vera e propria esperienza. Stavolta è vero”. (FAZ)"
        ],
        "image": "../../la-meglio-gioventu-1.png"
      }
    ]
  },
  {
    "title": "2012 - Puccini e la fanciulla",
    "subtitle": [""],
    "bodycopy": [
      "Il 16 settembre 2012 sarà ospite nella sala Black Box il regista italiano Paolo Benvenuti assieme a Paola Baroni. In Italia Benvenuti è noto per il suo particolare stile narrativo e il suo linguaggio visivo a sfondo storico culturale."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "Puccini e la fanciulla",
        "director": "Paolo Benvenuti, Paola Baroni",
        "country": "Italia",
        "releaseYear": 2009,
        "runtime": 78,
        "version": "S",
        "screeningDate": "16.09.2012",
        "readableDate": "2012-09-16",
        "screeningTime": "20:00",
        "actors": "Riccardo Moretti, Tania Squiliano, Giovanna Daddi, Debora Mattiello, Federica Chezzi",
        "subtitle": ["Senza dialoghi"],
        "bodycopy": [
          "Mentre Puccini sta componendo l’opera “La fanciulla del West“, l’ambiente che frequenta è pervaso da intrighi e rapporti a sfondo sessuale che influenzano lui stesso e il suo processo creativo."
        ],
        "image": "../../puccini-e-la-fanciulla.jpg"
      }
    ]
  },
  {
    "title": "2011 - Retrospettiva Pier Paolo Pasolini ",
    "subtitle": [""],
    "bodycopy": [
      "In febbraio e marzo 2011 il Filmclub 813 di Colonia e il Museo del Cinema di Düsseldorf (Black Box) tutti i cortometraggi e lungometraggi di Pier Paolo Pasolini, di cui ricorreva il 35° anniversario della morte il 2. November 2010. Con l'eccezione di SALÒ O LE 120 GIORNATE DI SODOMA che abbiamo già proiettato il 15.04.2010, ore 20:00."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "Le mura di Sana’a (Die Mauer von Sana’a)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1971,
        "runtime": 14,
        "version": "OmU",
        "screeningDate": "27.02.2011",
        "readableDate": "2011-02-27",
        "screeningTime": "15:00",
        "actors": "",
        "subtitle": [""],
        "bodycopy": [
          "Documentazione \"in forma di un appello all'UNESCO\" sull'architettura dei Sana'a, la capitale dello Yemen, che Pasolini aveva scelto per girare una sequenza poi tagliata fuori nella versione definitiva del DECAMERONE."
        ],
        "image": "../../le mura di sana.jpg"
      },
      {
        "title": "Appunti di viaggio per un film sull'India (Notizen für einen Film über Indien)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1968,
        "runtime": 35,
        "version": "OmU",
        "screeningDate": "14.03.2011",
        "readableDate": "2011-03-14",
        "screeningTime": "20:00",
        "actors": "Pier Paolo Pasolini",
        "subtitle": ["Con: Pier Paolo Pasolini"],
        "bodycopy": [
          "Un diario di viaggio, la raffigurazione di un tentativo di girare un film che racconta una leggenda del mondo mitico indiano: la storia di un maragià che offre il suo corpo in cibo ai cuccioli di una tigre che stanno per morire di fame. Pasolini intervista personaggi rappresentativi di diversi ceti sociali."
        ],
        "image": "../../Appunti.jpg"
      },
      {
        "title": "Il fiore delle Mille e una notte (Erotische Geschichten aus 1001 Nacht)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1974,
        "runtime": 129,
        "version": "OmU",
        "screeningDate": "05.03.2011",
        "readableDate": "2011-03-05",
        "screeningTime": "20:00",
        "actors": "Ninetto Davoli, Franco Citti, Franco Merli, Tessa Bouché, Ines Pellegrini, Margaret Clementi, Luigina Rocchi, Alberto Argentino, Francesco Paolo Governale, Salvatore Sapienza, Franca Sciutto",
        "subtitle": ["Mit: Pier Paolo Pasolini"],
        "bodycopy": [
          "Dei tre film costituenti la \"trilogia della vita\" questo è quello meglio riuscito. Una serie di avventure erotiche culmina ripetutamente in nudità e sessualità che lasciano effettivamente intuire quello che poteva aver in mente Pasolini parlando di espressione di una \"gioia di vivere\"."
        ],
        "image": "../../Il fiore.png"
      },
      {
        "title": "I racconti di Canterbury (Pasolinis tolldreiste Geschichten)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia/Frankreich",
        "releaseYear": 1972,
        "runtime": 110,
        "version": "OmU",
        "screeningDate": "04.03.2011",
        "readableDate": "2011-03-04",
        "screeningTime": "20:00",
        "actors": "Hugh Griffith, Laura Betti, Ninetto Davoli, Franco Citti, Josephine Chaplin, Alan Webb, Pier Paolo Pasolini, Vernon Dobtcheff, Adrian Street, Michael Balfour, Jenny Runacre, Tom Baker",
        "subtitle": [""],
        "bodycopy": [
          "Si può dire che si tratta della seconda parte della trasposizione della letteratura più insolente del Medioevo. Di nuovo la stessa grossolanità del DECAMERONE. Pasolini dipinge con molto gusto il cattivo gusto."
        ],
        "image": "../../I racconti di Canterbury.jpg"
      },
      {
        "title": "IL DECAMERON (DECAMERON)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1971,
        "runtime": 116,
        "version": "OmU",
        "screeningDate": "05.10.2022",
        "readableDate": "2022-10-05",
        "screeningTime": "19:00",
        "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
        "subtitle": [""],
        "bodycopy": [
          "Persone che non hanno nulla a che fare con l'allegoria, si dice, questa volta hanno attratto l'interesse di Pasolini dirigendo la sua attenzione sull'originalità della cultura meridionale con il suo temperamento focoso permettendogli di sfogarsi in un istrionismo furioso."
        ],
        "image": "../../ildecameron.jpg"
      },
      {
        "title": "Medea (Medea)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia/Germania/Frankreich",
        "releaseYear": 1969,
        "runtime": 110,
        "version": "OmU",
        "screeningDate": "27.01.2021",
        "readableDate": "2021-01-27",
        "screeningTime": "20:00",
        "actors": "Maria Callas, Massimo GIrotti, Laurent Terzeiff, Giuseppe Gentile, ;argareth Clémenti, Gerard Weiss, Sergio Tramonti, Luigi Barbini, Anna Maria Chio",
        "subtitle": [""],
        "bodycopy": [
          "L'intenzione di Pasolini è evidente: non vuole mettere in scena un altro classico con lo spirito di una falsità umanistica, ma un dramma etnologico del confronto interculturale."
        ],
        "image": "../../Medea.jpg"
      },
      {
        "title": "Il porcile (Der Schweinestall)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia/Frankreich",
        "releaseYear": 1969,
        "runtime": 99,
        "version": "OmU",
        "screeningDate": "23.02.2011",
        "readableDate": "2011-02-23",
        "screeningTime": "20:00",
        "actors": "Pierre Clémenti, Jean-Pierre Léaud, Alberto Lionello, Ugo Tognazzi, Marco Ferreri, Anne Wiazemsk<, Ninetto Davoli",
        "subtitle": [""],
        "bodycopy": [
          "Un attacco alla nostra società dei consumi con similitudini inquietanti. Pasolini sviluppa una comicità grottesca, per lui nuova, così velenosa che blocca la risata."
        ],
        "image": "../../Il porcile.jpg"
      },
      {
        "title": "Appunti per un'Orestiade africana (Notizen für eine afrikanische Orestie)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1970,
        "runtime": 65,
        "version": "OmU",
        "screeningDate": "27.02.2011",
        "readableDate": "2011-02-27",
        "screeningTime": "15:00",
        "actors": "Pier Paolo Pasolini, Gato Barbieri, Marcelli Melis",
        "subtitle": [""],
        "bodycopy": [
          "Il tentativo di una trasposizione dell'ORESTIADE di Eschilo nell'Africa moderna. In cerca di possibili luoghi per le sue riprese cinematografiche e di personaggi, Pasolini tiene un diario cinematografico."
        ],
        "image": "../../Orestiade.jpg"
      },
      {
        "title": "Uccellacci e uccellini (Große Vögel, kleine Vögel)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1966,
        "runtime": 88,
        "version": "OmU",
        "screeningDate": "19.02.2011",
        "readableDate": "2011-02-19",
        "screeningTime": "20:00",
        "actors": "Totò, Ninetto Davoli, Femi Benussi, Umberto Bevilacqua, Renato Capogna, Alfredo Leggi, Renato Montalbano, Flaminia Siciliano, Giovanni Tarallo, Vittorio Vittori, Domenico Modugno, Gabriele Baldini",
        "subtitle": [""],
        "bodycopy": [
          "Padre e figlio se ne vanno in giro. La loro meta rimane sconosciuta. Li accompagna un corvo parlante che spiega loro il mondo in modo cattedratico, fino a che, su due piedi, decidono di mangiarselo e continuare la strada da soli. Lo stile della messa in scena e del montaggio è un compendio delle possibilità che offre il linguaggio cinematografico."
        ],
        "image": "../../uccellacci e uccellini.jpg"
      },
      {
        "title": "Il Vangelo secondo Matteo (Das erste Evangelium - Matthäus)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia/Frankreich",
        "releaseYear": 1964,
        "runtime": 131,
        "version": "OmU",
        "screeningDate": "18.02.2011",
        "readableDate": "2011-02-18",
        "screeningTime": "20:00",
        "actors": "Enrique Irazoqui, Margherita Caruso, Susanna Pasolini, Marcello Morante, Rossana di Rocco, Mario Socrate, Alessandro Chierici",
        "subtitle": [""],
        "bodycopy": [
          "Pasolini gira il Vangelo secondo Matteo come se fosse un film neorealista sul Mezzogiorno. Non cela né il contenuto social-rivoluzionario né quello religioso del Vangelo."
        ],
        "image": "../../Il Vangelo.jpg"
      },
      {
        "title": "Sopralluoghi in Palestina (Motivsuche in Palästina)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1965,
        "runtime": 55,
        "version": "OmU",
        "screeningDate": "14.03.2011",
        "readableDate": "2011-03-14",
        "screeningTime": "20:00",
        "actors": "Pier Paolo Pasolini, Adrea Carraro",
        "subtitle": [""],
        "bodycopy": [
          "Per poter ricostruire delle località storiche per il film Il Vangelo secondo Matteo, Pasolini andò in Israele dove fece le necessarie ricerche. Questo film ne è il resoconto raccontato con la macchina da presa."
        ],
        "image": "../../sopralluoghi.jpg"
      },
      {
        "title": "La rabbia (Der Zorn)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1963,
        "runtime": 53,
        "version": "OmU",
        "screeningDate": "09.03.2011",
        "readableDate": "2011-03-09",
        "screeningTime": "18:00",
        "actors": "Giorgio Bassani, Renato Guttuso",
        "subtitle": [""],
        "bodycopy": [
          "Un film frammentato sulla rabbia o collera di Pasolini. Una rabbia contro il mondo borghese, la barbarie e l'intolleranza, contro i pregiudizi e la banalità. Un documento eccezionale che implicitamente testimonia un'altra volta l'autonomia della creazione, della poesia, della cultura."
        ],
        "image": "../../la_rabbia.jpg"
      },
      {
        "title": "La ricotta (Der Weichkäse)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia/Frankreich",
        "releaseYear": 1963,
        "runtime": 35,
        "version": "OmU",
        "screeningDate": "09.03.2011",
        "readableDate": "2011-03-09",
        "screeningTime": "18:00",
        "actors": "Orson Wells, Mario Cipriani, Laura Betti, Edmonda Aldini, Vittorio La Paglia, Maria Bernardini",
        "subtitle": [""],
        "bodycopy": [
          "La RICOTTA è un episodio del film RoGoPaG nel quale ai affianca ad altri episodi girati dai registi Roberto Rossellini, Jean-Luc Godard e Ugo Gregoretti.  Pasolini ha messo insieme un gruppo di personaggi che gli permettono di raffigurare in un microcosmo un universo di critica satirica, umorismo sarcastico e definizione estetico-politica."
        ],
        "image": "../../la ricotta.jpg"
      },
      {
        "title": "Accattone (Wer nie sein Brot mit Tränen aß)",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1961,
        "runtime": 116,
        "version": "OmU",
        "screeningDate": "04.02.2011",
        "readableDate": "2011-02-04",
        "screeningTime": "20:00",
        "actors": "Franco Citti, Franca Pasut, Silvana Corsini, Adele Cmbria, Paola Guidi, Adriana Asti",
        "subtitle": [""],
        "bodycopy": [
          "Con ACCATTONE Pasolini descrive per la prima volta il mondo con e nel linguaggio del film. Trasforma la struttura a episodi del Neorealismo nella compattezza ermetica della tragedia. La trama del piccolo magnaccia romano Accattone viene raccontata come la Passione di Cristo con gli strumenti del cinema della poesia."
        ],
        "image": "../../accattone.jpg"
     }
    ]
  },
  {
    "title": "2010 - Cento giorni a Palermo",
    "subtitle": ["Giuseppe Ferrara ospite del Club del Cinema Italiano"],
    "bodycopy": [
      "Con l'occasione di un seminario pubblico dell'Università Heinrich Heine di Düsseldorf, il regista italiano Giuseppe Ferrara, famoso per i suoi film politici (IL CASO ALDO MORO, GIOVANNI FALCONE) sarà ospite del Club del Cinema Italiano durante una serata speciale nella sala cinematografica Black Box.Un grande impegno sociale, politico e artistico fa parte della vita di Giuseppe Ferrara quasi fin dalla nascita, avvenuta nel 1932 a Castelfiorentino in provincia di Firenze. Già a scuola si fa notare per la sua indole polemica e ribelle che lo costringe a sostenere l'esame di maturità fuori sede. La sua resistenza costruttiva ha caratterizzato e caratterizza tutte le sue opere. In tal senso è un tipico rappresentante degli intellettuali italiani della sua generazione, sempre molto impegnati nella cultura e nell'arte. In Italia è diventato famoso soprattutto negli anni 80 con i suoi film in cui ricostruisce in stile documentaristico, gli eventi politici che hanno scosso l'Italia dalle sue fondamenta. Meno nota dall'opinione pubblica italiana è la sua intensa attività per la formazione di giovani cineasti e come autore di trasmissioni e libri su temi cinematografici. Anche i suoi ultimi film riflettono i lati oscuri della storia italiana: il significato delle donne nella Mafia, lo scandalo Calvi e il ruolo ambiguo delle Brigate Rosse."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Cento giorni a Palermo",
        "director": "Giuseppe Ferrara",
        "country": "Italia/Francia",
        "releaseYear": 1983,
        "runtime": 93,
        "version": "S",
        "screeningDate": "11.06.2010",
        "readableDate": "2010-06-11",
        "screeningTime": "20:00",
        "actors": "Lino Ventura, Giuliana, Liino Troisi, Stafano Saffa",
        "subtitle": [""],
        "bodycopy": [
          "Il film descrive gli sforzi del generale Dalla Chiesa (Lino Ventura), che nonostante si fosse distinto nella lotta contro le Brigate Rosse, viene spedito inaspettatamente dai politici a Palermo in qualità di prefetto di polizia. Il generale, fedele ai suoi obblighi e fiducioso nelle istituzioni dello stato, assume inizialmente questo ruolo per lui inconsueto e combatte con successo contro la mafia. Tuttavia si accorge che con le sue indagini, intraprese con tanta energia, incappa sempre di più nelle reti dei vari interessi e infine rischia di perdere qualsiasi sostegno."
        ],
        "image": "../../cento-giorni-a-palermo.jpg"
      },
      {
        "title": "MÖRDERISCHE GESELLSCHAFTEN - Die Geschichte der Mafia (Società micidiali - La storia della mafia)",
        "director": "Bernhard Pfletschinger",
        "country": "Germania",
        "releaseYear": 2010,
        "runtime": 90,
        "version": "OmU",
        "screeningDate": "06.10.2021",
        "readableDate": "2021-10-06",
        "screeningTime": "20:00",
        "actors": "",
        "subtitle": [
          "Arte-Vorpremiere in Anwesenheit des Regisseurs und weiteren Gästen"
        ],
        "bodycopy": [
          "Non esiste una sola mafia. Troppo diverse sono le strutture mafiose della\"camorra\" campana, della \"‘ndragheta\" calabrese e della siciliana \"cosa nostra\" e la loro storia. Bernd Pfletschinger si è dedicato alla ricerca delle origini e degli sviluppi delle singole organizzazioni e mostra come sia profondo il radicamento di tali organizzazioni nella storia d’Italia e della sua popolazione. Ma le loro losche trame non si limitano al territorio italiano, bensì si stanno sempre più internazionalizzando e diventando una minaccia per le democrazie del mondo. In questo film parlano storici, giudici penali e parenti di vittime esprimendo i loro pareri e i loro ricordi e cercando di spiegare l’irrefrenabile scalata e il potere quasi illimitato delle mafie. Bernhard Pfletschinger presenterà personalmente il suo film e parlerà assieme ad altri ospiti con il pubblico. A fine serata verràofferto un piccolo rinfresco. "
        ],
        "image": "../../moerderische-gesellschaften.jpg"
      }
    ]
  },
  {
    "title": "2007 - Libera Terra",
    "subtitle": ["Anteprima mondiale"],
    "bodycopy": [
      "Proiezione del film in presenza del regista Frank Wittlinger: 23 giugno 2007 - 19.30 h con successiva festa nello Studio del Filmmuseum."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Libera terra",
        "director": "Monica Colautti und Frank Wittlinger",
        "country": "Germania",
        "releaseYear": 2007,
        "runtime": 48,
        "version": "OmU",
        "screeningDate": "23.06.2007",
        "readableDate": "2007-06-23",
        "screeningTime": "19:30",
        "actors": "",
        "subtitle": [""],
        "bodycopy": [
          "Corleone – il nome, perlomeno da quando Hollywood iniziò a occuparsi del tema, è sinonimo di mafia e delitti di mafia. Corleone, la località da cui il boss dei boss, Bernardo Provenzano, poté tessere le sue trame per quarant'anni fino all'arresto avvenuto l'11 aprile 2006. Corleone, oggi un paese che con i comuni vicini circonda la cooperativa agricola antimafia \"Placido Rizzotto - Libera Terra“. 10 anni fa il sacerdote torinese, Don Luigi Ciotti, ebbe l'idea di fondare una cooperativa per utilizzare i possedimenti terrieri, confiscati a Cosa Nostra, come originariamente previsto e cioè per la produzione agricola. Grazie all'impegno di vari gruppi il progetto poté esserere alizzato 5 anni fa e, superate le difficoltà iniziali, oggi è bene accettato dagli abitanti della zona e sostenuto da tanti cittadini italiani. I membri della cooperativa non si sono lasciati né scoraggiare dai massicci ostacoli incontrati né dalle minacce ricevute (sementi distrutte, cane impiccato in mezzo ai campi, ecc.). Il film presenta l'iniziativa e la situazione subito dopo la cattura di Provenzano, lascia parlare i membri della cooperativa, gli abitanti e gli attivisti antimafia e mostra allo stesso tempo una mafia che, anche se non compare direttamente nel film, è sempre presente."
        ],
        "image": "../../libera-terra-7.jpg"
      }
    ]
  },
  {
    "title": "2005 - Mario Adorf",
    "subtitle": [""],
    "bodycopy": [
      "Molti dei film italiani in cui recita Mario Adorf sono stati proiettati in Germania soltanto doppiati e spesso unicamente alla televisione. Perciò esistono poche pellicole in lingua originale con i sottotitoli tedeschi.Per questo motivo siamo lieti di potervi presentare in dicembre i due seguenti film in ocasione della mostra dedicata all'attoche in corso nel Museo del Cinema di Düsseldorf."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Milano Calibro 9",
        "director": "Fernando di Leo",
        "country": "Italia",
        "releaseYear": 1972,
        "runtime": 98,
        "version": "OmU",
        "screeningDate": "14.12.2005",
        "readableDate": "2005-12-14",
        "screeningTime": "21:30",
        "actors": "Gastone Moschin, Barbara Bouchet, Mario Adorf, Frank Wolff, Luigi Pistilli, Ivo Garrani, Philippe Leroy, Lionel Stander",
        "subtitle": ["Rassegna di Mario Adorf"],
        "bodycopy": [
          "Uno dei più significativi film polizieschi: Ugo Piazza esce di prigione dopo tre anni. L’“Americano” crede che Ugo gli abbia trafugato 300.000 dollari e gli mette alle calcagna Rocco Musco (Mario Adorf), un uomo violento e privo di scrupoli. Ma non solo lui è alla caccia dei soldi ....E così la storia continua tra sorprendenti capriole. Un film caratterizzato da inquadrature moderne e la musica avvincente di Luis Enríquez Bacalov, premiato con l'Oscar (“Il postino”, “Il Vangelo secondo Matteo”). Noi mostriamo la versione originale in tutta lunghezza. La versione doppiata in tedesco era stata notevolmente molto accorciata a suo tempo."
        ],
        "image": "../../calibro-9.jpg"
      },
      {
        "title": "Francesco (Franziskus)",
        "director": "Liliana Cavani",
        "country": "Italia/Germania",
        "releaseYear": 1989,
        "runtime": 130,
        "version": "OmU",
        "screeningDate": "20.12.2005",
        "readableDate": "2005-12-20",
        "screeningTime": "19:00",
        "actors": "Mickey Rourke, Helena Bonham Carter, Andréa Ferrèol, Nikolaus Dutsch, Peter Berling, Mario Adorf",
        "subtitle": ["Rassegna di Mario Adorf"],
        "bodycopy": [
          "Il film racconta la storia di San Francesco d'Assisi, il fondatore dell'ordine francescano. Nato nel 1182, Francesco Bernadone lascia incompreso la sua famiglia abbiente per andare a vivere assieme ai poveri e agli ammalati. Per lungo tempo lotta per il riconoscimento del suo movimento da parte del Vaticano. Dopo averlo ricevuto, cade in profonda disperazione di fronte alla richiesta dei suoi discepoli di una “Regola”. Allora si ritira nei boschi alla ricerca di illuminazione spirituale. Mario Adorf ha un piccolo ruolo: impersona il Cardinale Ugolino dei Conti di Segni."
        ],
        "image": "../../franziskus.jpg"
      }
    ]
  },
  {
    "title": "2004 - Con gli occhi di lei",
    "subtitle": ["Sei registe italiane raccontano"],
    "bodycopy": [
      "C'è uno sguardo specificatamente femminile sull'Italia di oggi? Una serie di otto film di sei registe italiane cerca di trovare una risposta a questa domanda. Una particolare attrazione sarà la presenza della regista Wilma Labate che presenterà il suo ultimo film.",
      "La serie, concepita dall'Istituto italiano di cultura di Colonia può essere mostrata pure a Düsseldorf grazie alla cooperazione con il Club del Cinema Italiano, la sala Black Box, il Museo del Cinema di Düsseldorf e il supporto di Marisa e Joachim Manzin, traduttori di italiano-tedesco."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "La mia generazione (La mia generazione)",
        "director": "Wilma Labate",
        "country": "Italia",
        "releaseYear": 1996,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "26.04.2004",
        "readableDate": "2004-04-26",
        "screeningTime": "19:30",
        "actors": "Stefano Accorsi, Claudio Amendola, Francesca Neri",
        "subtitle": [""],
        "bodycopy": [
          "In Sicilia, in un carcere speciale, Braccio, detenuto politico, viene prelevato con un furgone per essere tradotto a Milano, per ottenere alcuni colloqui con l'ex fidanzata, Giulia. Il Capitano dei Carabinieri, responsabile del trasferimento, con sagace psicologia, riesce a superare l'istintiva diffidenza del detenuto trattandolo da uomo. "
        ],
        "image": "../../la mia generazione.jpg"
      },
      {
        "title": "Tano da morire",
        "director": "Roberta Torre",
        "country": "Italia",
        "releaseYear": 1997,
        "runtime": 80,
        "version": "OmU",
        "screeningDate": "16.04.2004",
        "readableDate": "2004-04-16",
        "screeningTime": "19:30",
        "actors": "Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
        "subtitle": [""],
        "bodycopy": [
          "Angela, nata e cresciuta a Ballarò, il quartiere del mercato di Palermo, a vent'anni sposa Saro e con lui condivide una vita fatta di traffico di droga e guadagni facili. Quando conosce Masino, diventato il braccio destro di suo marito, nasce tra i due un'attrazione irresistibile"
        ],
        "image": "../../Tano-da-morire.jpg"
      },
      {
        "title": "Angela",
        "director": "Roberta Torre",
        "country": "Italia",
        "releaseYear": 2002,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "02.06.2004",
        "readableDate": "2004-06-02",
        "screeningTime": "19:30",
        "actors": " Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
        "subtitle": [""],
        "bodycopy": [
          "Angela, nata e cresciuta a Ballarò, il quartiere del mercato di Palermo, a vent'anni sposa Saro e con lui condivide una vita fatta di traffico di droga e guadagni facili. Quando conosce Masino, diventato il braccio destro di suo marito, nasce tra i due un'attrazione irresistibile."
        ],
        "image": "../../Angela.jpg"
      },
      {
        "title": "Rose e pistole",
        "director": "Carla Apuzzo",
        "country": "Italia",
        "releaseYear": 1998,
        "runtime": 81,
        "version": "OmU",
        "screeningDate": "21.05.2004",
        "readableDate": "2004-05-21",
        "screeningTime": "19:30",
        "actors": "Anna Anunirati, Duccio Giordano, Luigi Petrucci",
        "subtitle": [""],
        "bodycopy": [
          "Tra Bagnoli e i Campi Flegrei, Rosa e Angelo, entrambi ventenni, sono in fuga dal marito di lei. Il ricco macellaio Pappalardo ha assunto un killer..."
        ],
        "image": "../../rose-e-pistole.jpg"
      },
      {
        "title": "L’ inverno",
        "director": "Nina Di Majo",
        "country": "Italia",
        "releaseYear": 2001,
        "runtime": 97,
        "version": "OmU",
        "screeningDate": "19.05.2004",
        "readableDate": "2004-05-19",
        "screeningTime": "19:30",
        "actors": "Valeria Bruni Tedeschi, Valeria Golino, Fabrizio Gifuni, Yorgo Voyagis, Paolo Paolini",
        "subtitle": [""],
        "bodycopy": [
          "In una metropoli post-industriale del Norditalia s'incontrano due coppie alle prese con i propri egoismi e con l'incapacità di relazionarsi e di comunicare. "
        ],
        "image": "../../L'inverno.jpg"
      },
      {
        "title": "Non è giusto (Es ist nicht fair)",
        "director": "Antonietta De Lillo",
        "country": "Italia",
        "releaseYear": 2001,
        "runtime": 102,
        "version": "OmU",
        "screeningDate": "14.05.2004",
        "readableDate": "2004-05-14",
        "screeningTime": "19:30",
        "actors": "Maddalena Polistina, Daniel Podromo, Antonio Manzini, Valerio Binasco",
        "subtitle": [""],
        "bodycopy": [
          "Sofia e Valerio, entrambi con famiglie divise, durante un'afosa estate napoletana imparano a conoscersi. Sono due ragazzini ancora sottoposti agli sbalzi d'umore e alla confusione generazionale dei loro genitori. Nell'attesa delle vacanze e dell'entrata in un'età più adulta impareranno a guardare i grandi con distacco."
        ],
        "image": "../../non-e-giusto.jpg"
      },
      {
        "title": "Domenica (Domenica)",
        "director": "Wilma Labate",
        "country": "Italia",
        "releaseYear": 2001,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "28.04.2004",
        "readableDate": "2004-04-28",
        "screeningTime": "19:30",
        "actors": "Claudio Amendola, Annabella Sciorra, Domenica Giuliano, ",
        "subtitle": [""],
        "bodycopy": [
          "Un ispettore di polizia e una bambina orfana affrontano insieme un viaggio lungo un giorno per le strade di Napoli. Tra i vicoli, in un garbuglio di piccoli avvenimenti, la bambina conduce il taciturno e rude ispettore per una Napoli povera, segreta, innocente e maledetta."
        ],
        "image": "../../Domenica.jpg"
      },
      {
        "title": "Domani (Der Tag danach)",
        "director": "Francesca Archibugi",
        "country": "Italia",
        "releaseYear": 2001,
        "runtime": 88,
        "version": "OmU",
        "screeningDate": "22.04.2004",
        "readableDate": "2004-04-22",
        "screeningTime": "19:30",
        "actors": "Marco Baliani, Ornella Muti, David Bracci, Valerio Mastandrea",
        "subtitle": [""],
        "bodycopy": [
          "Dopo il terremoto del 1997 in Umbria, un intero paese ritroverà la voglia di ricostruire la vita e gli affetti, di amare e sorridere nuovamente."
        ],
        "image": "../../Domani.jpg"
      }
    ]
  },
  {
    "title": "2004 - La Gabbianella e il Gatto",
    "subtitle": [""],
    "bodycopy": [
      "Film di cartoni animati per bambini, diretto, scritto e disegnato da Enzo D'Alò, presentato in occasione della Festa della Repubblica Italiana il Museo del Cinema di Düsseldorf, il cinema BLACK BOX, la sala all’interno del Museo del cinema con il supporto dei traduttori Joachim e Marisa Manzin."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "La Gabbianella e il Gatto (Wie Kater Zorbas der kleinen Möwe das Fliegen beibrachte)",
        "director": "Enzo D'Alò",
        "country": "Italia",
        "releaseYear": 1999,
        "runtime": 78,
        "version": "OF",
        "screeningDate": "29.05.2004",
        "readableDate": "2004-05-29",
        "screeningTime": "15:00",
        "actors": "Regisseur, Drehbuchschreiber und Zeichner: Enzo D'Alò",
        "subtitle": [""],
        "bodycopy": [
          "Kengah, una gabbiana avvelenata da una macchia di petrolio, in punto di morte riesce ad affidare il proprio uovo al gatto Zorba strappandogli tre promesse:Kengah, una gabbiana avvelenata da una macchia di petrolio, in punto di morte riesce ad affidare il proprio uovo al gatto Zorba strappandogli tre promesse:quella di non mangiare l’uovo; di averne cura finché non si schiuderà; di insegnare a volare al nascituro.La gabbianella orfana viene battezzata Fortunata dall’intera comunità dei gatti. La piccola Fortunata dovràimparare a conoscersi e capire di non essere un gatto, prima di imparare a volare."
        ],
        "image": "../../gabianellagatto.jpg"
      }
    ]
  },
  {
    "title": "2004 - Casomai (Trauen wir uns?!)",
    "subtitle": ["Prima visione"],
    "bodycopy": [
      "I Filmkunstkinos di Düsseldorf, il cinema Black Box e il Club del CInema italiano del Museo del cinema di Düsseldorf, con il supporto dei traduttori Joachim e Marisa Manzin presentano in prima visione in Germania questo film già proiettato con grande successo in Italia. Saranno presenti il regista Alessandro D'Alatri e Rino Manni, l'attore che impersona il prete."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "CASOMAI (Trauen wir uns?!)I",
        "director": "Alessandro D'Alatri",
        "country": "Italia",
        "releaseYear": 2002,
        "runtime": 114,
        "version": "OmU",
        "screeningDate": "21.08.2004",
        "readableDate": "2004-08-21",
        "screeningTime": "19:30",
        "actors": "Stefania Rocca, Fabio Volo, Rino Manni, Sara D’Amario",
        "subtitle": [""],
        "bodycopy": [
          "Il desiderio di una coppia e le idee poco convenzionali di un prete formano il canovaccio di uno dei più inconsueti film della storia del cinema sul tema matrimonio.",
          "Tommaso e Stefania vogliono sposarsi. Però sono veramente i soli responsabili della loro futura felicità? Il prete, Don Livio, ha qualche dubbio. Come un Don Camillo dei nostri giorni mette in scena una cerimonia nunziale inaspettata e sembra concentrarsi più sugli invitati che sulla coppia stessa. Infatti non sono loro i responsabili della buona o cattiva riuscita della futura vita matrimoniale degli sposini?",
          "Con una serie di sorprendenti trovate spiritose e umoristiche, il film tratta con leggerezza un tema esistenziale del nostro tempo: la capacità di affrontare la vita di coppia, la responsabilità per se stessi e gli altri, e la sensibilità per le note più sommesse della vita in un mondo sempre più \"chiassoso\".",
          "Durante il festival “Cinema! Italia 2003” il film è stato il favorito non solo di tutti gli spettatori in Germania, ma anche il più apprezzato dal pubblico di Düsseldorf."
        ],
        "image": "../../casomai.jpg"
      },
      {
        "title": "Il mestiere delle armi (Der Medici krieger)",
        "director": "Ermanno Olmi",
        "country": "Italia/Francia/Germania",
        "releaseYear": 2001,
        "runtime": 105,
        "version": "OmU",
        "screeningDate": "06.12.2003",
        "readableDate": "2003-12-06",
        "screeningTime": "19:30",
        "actors": "Hristo Jivkov, Sergio Grammatico, Fabio Giubbani, Sandra Ceccarelli, Dessy Tenekedjieva, Dimitar Ratchkov",
        "subtitle": [""],
        "bodycopy": [
          "Inverno 1526. L’Italia è minacciata da un esercito imponente. L’imperatore Carlo V ha mandato i suoi lanzichenecchi sotto il comando del Generale Georg von Frundsberg in Italia allo scopo di attaccare lo Stato della Chiesa, alleato della Francia. Le truppe papali al comando del Generale della Rovere si oppongono a quelle imperiali, primo fra tutti l’abile capitano delle temute Bande Nere: Giovanni de’ Medici.",
          "Il film inizia con l’esposizione del suo feretro e poi riprende dall’inizio la storia, nella quale l’eroismo si contrappone alle moderne tecnologie belliche. Olmi non ha semplicemente girato un film storico, ma ha messo in scena una serie di immagini arcaiche, silenziose, in parte meditative, in cui prevale l’aspetto umano. Il film è stato premiato con 9  “Donatelli”."
        ],
        "image": "../../ilmestieredelle armi.jpg"
      }
    ]
  }
]
